import React from 'react';
import { Row, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import Body from '../Components/layout/Body';
import LoginNotice from './LoginNotice';

const CREATE_HELP = `
<div>
  <p>To store the data for a client evaluation, you need to select the client first - that's how Access Nav will know whose data it is and how to store it.</p>
  <p>So if it's your first time using Access Nav with a client / student, you'll need to create a new client.</p>
  <p>The only required info here is a Client Username. This must be unique (we'll tell you if it's not).</p>
  <p>The Preferred Name and Pronouns allow Access Nav to personalize some of the instructions, which can make things more friendly and clear. If you omit these, we'll use 'the client' and 'they / them' as defaults.</p>
  <p><strong>If complete privacy is a concern,</strong> you may want to avoid identifiable names when creating the client. </p>
  <p><strong>Note: </strong>Once you've created the client, you can change the Preferred Name and Pronouns, but you won't be able to change the Client Username.</p>
</div>
`;

// **Q** This is almost identical to UsersCreate.js. May want to consolidate.
//content sub-component with unique content for this page
function UsersCreateClientContent(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    onChangeUsername,
    onChangeAlias,
    onChangePronoun,
    userStatus
  } = props;

  const pronounsLegend = `Pronouns`;
  const pronounsId = "pronouns";
  const pronounsBtns = [
    {
      value: 'they',
      label: `They / Them`,
      moreInfo: ''
    },
    {
      value: 'he',
      label: `He / Him`,
      moreInfo: ''
    },
    {
      value: 'she',
      label: `She / Her`,
      moreInfo: ''
    }

  ];


  /* invalid property turns the field border red when value is invalid (like empty).
     required property doesn't have any visual behavior -- it may announce required to screen readers
  */
  return(
    <>
    {!loggedIn && <LoginNotice message="To create a client, you first need to " />}
    <Row>
      <Col>
        <Form>
          <FormGroup>
            <Label for="username" className="aa-bold-text">
              Client Username <span className="aa-field-required">*</span>
            </Label>
            <Input
              id="username"
              value={username}
              onChange={onChangeUsername}
              name="username"
              type="textfield"
              invalid={userStatus === 0}
              required
              disabled={!loggedIn}
            />
          </FormGroup>
          <FormGroup>
            <Label for="alias" className='aa-bold-text'>
              Preferred Name <span className="aa-more-info">(what the client prefers to be called, like 'Alex')</span>
            </Label>
            <Input
              id="alias"
              value={alias}
              onChange={onChangeAlias}
              name="alias"
              type="textfield"
              disabled={!loggedIn}
            />
          </FormGroup>
          <FormGroup tag="fieldset" key={pronounsId}>
            <legend>{pronounsLegend}</legend>
            {pronounsBtns.map((btn, index) =>
              <FormGroup check key={index}>
                <Input
                  id={pronounsId+btn.value}
                  value={btn.value}
                  checked={pronoun===btn.value}
                  onChange={onChangePronoun}
                  name={pronounsId}
                  disabled={!loggedIn}
                  type="radio"
                />
                {' '}
                <Label for={pronounsId+btn.value} check>
                  {btn.label}
                  {' '}
                </Label>
              </FormGroup>
            )}
          </FormGroup>
        </Form>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersCreateClient(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    onChangeUsername,
    onChangeAlias,
    onChangePronoun,
    userStatus,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Create a new client",
    subTitle: "To get started, enter a unique username for this client, so we know how to store the data. You can also enter a preferred name and pronouns -- that makes things a little clearer and friendlier!",
    learnMore: {linkText: "Learn More about client names and data storage",
                title: "Client names and data storage",
                content: CREATE_HELP
                },
    nextRoute: '', 
    sidebar: false
  }

  console.log("rendering UsersCreateClient, userStatus: " + userStatus);

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersCreateClientContent 
          loggedIn={loggedIn}
          username={username}
          onChangeUsername={onChangeUsername}
          alias={alias}
          onChangeAlias={onChangeAlias}
          pronoun={pronoun}
          onChangePronoun={onChangePronoun}
          userStatus={userStatus}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersCreateClient;